import { Form } from 'formik';
import styled from 'styled-components';
const StyledForm = styled(Form) `
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
`;
export { StyledForm };
